import { createAction } from '@reduxjs/toolkit';

export const exchangeActions = {
  getExchangeRate: createAction('exchange/GET_EXCHANGE_RATE'),
  getExchangeRateSuccess: createAction('exchange/GET_EXCHANGE_RATE_SUCCESS'),
};
